import Select from '@frontile/forms/components/select';
import type { SelectSignature } from '@frontile/forms/components/select';

export default class RemoteSelect<T = unknown> extends Select<SelectSignature<T>> {
  override onFilterChange = (event: Event) => {
    // @ts-expect-error
    this.args.onFilterChange?.(event);
    this.filterValue = (event.target as HTMLInputElement).value;
  };
}
